<template>
    <div class="row">
            <div class="col-sm-12">
                <!-- <b-form-group
        id="isExited"
        label="Customer has exited ?"
        label-for="isExited"
>
    <b-form-radio-group
            v-model="exitDetails.isExited"
            autocomplete="no"
            :options="radioOptions"
            :text-field="textField"
            :value-field="valueField"
            data-vv-name="isExited"
            :class="{
            'is-invalid': errors.has(
                'isExited'
            ),
        }"
    >
    
    </b-form-radio-group>
</b-form-group> -->
<b-form-group
                                        id="input-group-1"
                                        :label="status=='active' ? 'Client Activation Date' : 'Client Inactivation Date'"
                                        label-for="exitDate"
                                >
                                   
                                    <div class="form-group custom-datepicker">
                                        <date-picker
                                                ref="start date"
                                                v-model="exitDetails.date"
                                                class="form-control"
                                                name="exitDate"
                                                format="DD/MM/YYYY"
                                                lang="en"
                                                :class="{
                                                                    'is-invalid':
                                                                        errors.has(
                                                                            'exitDate'
                                                                        ),
                                                                }"

                                        ></date-picker>

                                        <i :class="[{'disable-input': false,},'icon-calendar', ]"></i>
                                    </div>

                                </b-form-group>
                                <b-form-group 
                                id="input-group-1"
                                label="Reason"
                                label-for="reason"
                        >
                            <b-form-textarea
                                    id="reason"
                                    v-model="exitDetails.reason"
                                    v-validate="{
                                    required: true,
                                }"
                                    rows="3"
                                    placeholder="Enter reason"
                                    name="reason"
                                    :class="{
                                    'is-invalid': errors.has('reason'),
                                }"
                            ></b-form-textarea>
                        </b-form-group>
            </div>
           
        </div>
</template>
<script>
import DatePicker from 'vue2-datepicker'

export default {
    /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */

        components:{
        DatePicker
    },    
    props: {
        status: {
                type: String,
            },
    }, // End of Component > props

    /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
    data() {
        return {
            exitDetails:{
                    date:null,
                    reason:null
                },
                textField: 'text',
            valueField: 'value',
                radioOptions: [
                { text: 'Yes', value: true },
                { text: 'No', value: false },
            ],
        }
    }, // End of Component > data

    /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
    computed: {}, // End of Component > methods

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    mounted() {}, // End of Component > computed
    watch: {
        exitDetails: {
            handler(newValue) {
                this.$emit('update-exit-details', newValue); // Emit updated exitDetails data
            },
            deep: true
        }
    },
    /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
    methods: {}, // End of Component > mounted
} // End of export default
</script>
